import { all, put, takeEvery } from "redux-saga/effects";
import { SagaIterator } from "redux-saga";
import {
  CREATE_BRANCH_REQUEST,
  CREATE_BRANCH_SUCCESS,
  CREATE_BRANCH_FAILURE,
  FETCH_BRANCHES_REQUEST,
  FETCH_BRANCHES_SUCCESS,
  FETCH_BRANCHES_FAILURE,
  EDIT_BRANCH_REQUEST,
  EDIT_BRANCH_SUCCESS,
  EDIT_BRANCH_FAILURE,
  DELETE_BRANCH_SUCCESS,
  DELETE_BRANCH_FAILURE,
  DELETE_BRANCH_REQUEST,
  SET_LOADING_STATE,
  RESET_LOADING_STATE,
} from "../constants";

import {
  firebaseCreateBranch,
  firebaseDeleteBranch,
  firebaseFetchBranches,
  firebaseUpdateBranch,
} from "../api/branch";

function* createBranchFn({ payload }: any): any {
  try {
    yield put({ type: SET_LOADING_STATE });
    const response = yield firebaseCreateBranch(payload);
    if (response) {
      yield put({
        type: CREATE_BRANCH_SUCCESS,
        payload: { newBranch: response },
      });
      yield put({ type: RESET_LOADING_STATE })

    } else {
      yield put({ type: CREATE_BRANCH_FAILURE });
      yield put({ type: RESET_LOADING_STATE });
    }
  } catch (err) {
    yield put({ type: CREATE_BRANCH_FAILURE });
    yield put({ type: RESET_LOADING_STATE });
  }
}
function* fetchBranchesFn({ payload }: any): any {
  try {
    yield put({ type: SET_LOADING_STATE });
    const response = yield firebaseFetchBranches(payload);
    if (response) {
      yield put({
        type: FETCH_BRANCHES_SUCCESS,
        payload: { branches: response },
      });
      yield put({ type: RESET_LOADING_STATE });
    } else {
      yield put({ type: FETCH_BRANCHES_FAILURE });
      yield put({ type: RESET_LOADING_STATE });
    }
  } catch (err) {
    yield put({ type: FETCH_BRANCHES_FAILURE });
    yield put({ type: RESET_LOADING_STATE });
  }
}
function* updateBranchFn({ payload }: any): any {
  try {
    yield put({ type: SET_LOADING_STATE });
    const response = yield firebaseUpdateBranch(payload);
    if (response) {
      yield put({
        type: EDIT_BRANCH_SUCCESS,
        payload: { branches: response },
      });
      yield put({ type: RESET_LOADING_STATE });
    } else {
      yield put({ type: EDIT_BRANCH_FAILURE });
      yield put({ type: RESET_LOADING_STATE });

    }
  } catch (err) {
    yield put({ type: EDIT_BRANCH_FAILURE });
    yield put({ type: RESET_LOADING_STATE });

  }
}
function* deleteBranchFn({ payload }: any): any {
  try {
    yield put({ type: SET_LOADING_STATE });
    const response = yield firebaseDeleteBranch(payload);
    if (response) {
      yield put({
        type: DELETE_BRANCH_SUCCESS,
        payload: { branches: response },
      });
      yield put({ type: RESET_LOADING_STATE });
    } else {
      yield put({ type: DELETE_BRANCH_FAILURE });
      yield put({ type: RESET_LOADING_STATE });
    }
  } catch (err) {
    yield put({ type: DELETE_BRANCH_FAILURE });
    yield put({ type: RESET_LOADING_STATE });
  }
}
export default function* branchSaga(): SagaIterator {
  yield all([
    takeEvery(CREATE_BRANCH_REQUEST, createBranchFn),
    takeEvery(FETCH_BRANCHES_REQUEST, fetchBranchesFn),
    takeEvery(EDIT_BRANCH_REQUEST, updateBranchFn),
    takeEvery(DELETE_BRANCH_REQUEST, deleteBranchFn),
  ]);
}
